/* eslint-disable import/no-mutable-exports */
/* eslint-disable prefer-arrow/prefer-arrow-functions */
import { Injector } from '@angular/core';

export let rootInjector: Injector;

export function setRootInjector(injector: Injector): void {
  rootInjector = injector;
}
